import { createSuitMixin as t } from "../mixins/suit.js";
import { renderCompat as e } from "../util/vue-compat/index-vue2.js";
import { createWidgetMixin as s } from "../mixins/widget.js";
import { connectConfigure as i } from "instantsearch.js/es/connectors/index.js";
export default {
  inheritAttrs: !1,
  name: "AisConfigure",
  mixins: [t({
    name: "Configure"
  }), s({
    connector: i
  }, {
    $$widgetType: "ais.configure"
  })],
  computed: {
    widgetParams: function widgetParams() {
      return {
        searchParameters: Object.assign({}, this.$attrs)
      };
    }
  },
  render: e(function (t) {
    var e = this.$scopedSlots.default;
    return this.state && e ? t("div", {
      class: this.suit()
    }, [e({
      refine: this.state.refine,
      searchParameters: this.state.widgetParams.searchParameters
    })]) : null;
  })
};